import { render, staticRenderFns } from "./DealCardExpandedTabs.vue?vue&type=template&id=df29831a&scoped=true"
import script from "./DealCardExpandedTabs.vue?vue&type=script&lang=js"
export * from "./DealCardExpandedTabs.vue?vue&type=script&lang=js"
import style0 from "./DealCardExpandedTabs.vue?vue&type=style&index=0&id=df29831a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df29831a",
  null
  
)

export default component.exports